export const visit = (vm, at) => {
at({ "es": { "hc-0133": { "sample-data-banner": { "title": "Modo de datos de muestra", "description": "Puedes explorar y modificar estos datos hasta que los tuyos est\xE9n listos para subirlos." } } } });
};